var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.innerVisible,
        width: "870px",
        height: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("cargo-ag-grid", {
        staticStyle: { width: "100%", height: "400px" },
        attrs: {
          "grid-options": _vm.chargeGrid.gridOptions,
          "column-defs": _vm.chargeGrid.columnDefs,
          "grid-params": _vm.chargeGrid.gridParams,
          "row-data": _vm.chargeGrid.rowData
        },
        on: {
          "update:gridParams": function($event) {
            return _vm.$set(_vm.chargeGrid, "gridParams", $event)
          },
          "update:grid-params": function($event) {
            return _vm.$set(_vm.chargeGrid, "gridParams", $event)
          },
          gridReady: _vm.onGridReady
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }